import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { AgentSessionListItemProps } from './AgentSessionListItem.tsx';

export const AgentSessionListItemLoadable: LoadableType<AgentSessionListItemProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentSessionListItem" */ './AgentSessionListItem.tsx'
			)
		).AgentSessionListItem,
});
